import request from '@/utils/request'

// ============ 菜品管理 API ============
export const getDishList = (params) => {
    return request.get('/houtai/htgetUserDishes', { params })
}